import Vue from 'vue'
import config from '@/config/index'

const milliseconds = 5000

export default {
  namespaced: true,
  state: {
    shared_timeout: milliseconds,
    shared_color: '',
    shared_mode: '',
    shared_snackbar: false,
    shared_text: ''
  },
  getters: {
    timeout (state) {
      return state.shared_timeout
    },
    color (state) {
      return state.shared_color
    },
    mode (state) {
      return state.shared_mode
    },
    snackbar (state) {
      return state.shared_snackbar
    },
    text (state) {
      return state.shared_text
    }
  },
  mutations: {
    snackbarTimeout (state, payload) {
      state.shared_timeout = payload
    },
    snackbarColor (state, payload) {
      state.shared_color = payload
    },
    snackbarMode (state, payload) {
      state.shared_mode = payload
    },
    storeSnackbar (state, payload) {
      state.shared_snackbar = payload
    },
    snackbarText (state, payload) {
      state.shared_text = payload
    },
    snackbarOnSuccess (state, payload) {
      state.shared_text = payload
      state.shared_snackbar = true
      state.shared_color = 'success'
    },
    snackbarOnInfo (state, payload) {
      state.shared_text = payload
      state.shared_snackbar = true
      state.shared_color = 'info'
    },
    snackbarOnError (state, payload) {
      state.shared_text = payload
      state.shared_snackbar = true
      state.shared_color = 'error'
    },
    snackbarOnWarning (state, payload) {
      state.shared_text = payload
      state.shared_snackbar = true
      state.shared_color = 'warning'
    }
  },
  actions: {
    snackbarTimeout ({ commit }, payload) {
      commit('snackbarTimeout', payload)
    },
    snackbarColor ({ commit }, payload) {
      commit('snackbarColor', payload)
    },
    snackbarMode ({ commit }, payload) {
      commit('snackbarMode', payload)
    },
    storeSnackbar ({ commit }, payload) {
      commit('storeSnackbar', payload)
    },
    snackbarText ({ commit }, payload) {
      commit('snackbarText', payload)
    },
    snackbarOnSuccess ({ commit }, payload) {
      commit('snackbarOnSuccess', payload)
    },
    snackbarOnSaveSuccess ({ commit }, payload) {
      commit('snackbarOnSuccess', 'บันทึกข้อมูลเรียบร้อย')
    },
    snackbarOnDeleteSuccess ({ commit }, payload) {
      commit('snackbarOnSuccess', 'ลบข้อมูลเรียบร้อย')
    },
    snackbarOnInfo ({ commit }, payload) {
      commit('snackbarOnInfo', payload)
    },
    snackbarOnError ({ commit }, payload) {
      commit('snackbarOnError', payload)
    },
    snackbarOnWarning ({ commit }, payload) {
      commit('snackbarOnWarning', payload)
    },
    snackbarOnLoadFail ({ commit }, payload) {
      commit('snackbarOnError', payload)
      // commit('snackbarOnError', 'Error --  "' + payload.response.config.url + '"  -- [' + payload.response.status + ' ' + payload.response.statusText + ']')
    },
    /*snackbarOnLoadFailWithMessage ({ commit }, payload) {
      commit('snackbarOnError', payload)
    },*/
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/snackbar.js